import React, { createContext, useContext, useState, useEffect } from 'react'
import api from '../services/api'
import { translateApiError } from '../utils/errorMessages'
import { getPbToken, setPbToken, removePbToken } from '../utils/authTokenStorage'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = getPbToken()
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      fetchUser()
    } else {
      setLoading(false)
    }
  }, [])

  const fetchUser = async () => {
    try {
      const response = await api.get('/auth/me')
      const u = response.data.user
      setUser(u)
    } catch (error) {
      removePbToken()
      delete api.defaults.headers.common['Authorization']
    } finally {
      setLoading(false)
    }
  }

  const login = async (login, password) => {
    try {
      const response = await api.post('/auth/login', { login, password })
      const { token, user } = response.data
      if (!token || !user) {
        console.error('Missing token or user in response:', response.data)
        return { 
          success: false, 
          error: 'Неверный формат ответа от сервера' 
        }
      }
      setPbToken(token)
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      // Устанавливаем пользователя из ответа логина (уже содержит права)
      setUser(user)
      // Также загружаем полные данные через /me для актуальности
      await fetchUser()
      return { success: true, user: user }
    } catch (error) {
      console.error('Login error:', error)
      console.error('Error response:', error.response?.data)
      console.error('Error status:', error.response?.status)
      const rawError = error.response?.data?.error || error.message || 'Ошибка входа'
      return { success: false, error: translateApiError(rawError) }
    }
  }

  const logout = async () => {
    try {
      await api.post('/auth/logout')
    } catch {
      /* сеть/401 — всё равно сбрасываем клиентское состояние */
    }
    removePbToken()
    delete api.defaults.headers.common['Authorization']
    setUser(null)
  }

  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    login,
    logout,
    fetchUser
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

